module.exports = __webpack_public_path__ + "img/paypal.9539c058.png";